import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface ChatConfig {
  chatAccess: boolean;
  viewAccess: boolean;
  loading: boolean;
}

interface ChatState {
  salesUserId: string;
  currentSessionId: string;
  chatConfig: ChatConfig;
}

const initialState: ChatState = {
  salesUserId: "",
  currentSessionId: "",
  chatConfig: {
    chatAccess: false,
    viewAccess: false,
    loading: true,
  },
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setSalesUserId(state, action: PayloadAction<string>) {
      state.salesUserId = action.payload;
    },
    setCurrentSessionId(state, action: PayloadAction<string>) {
      state.currentSessionId = action.payload;
    },
    setChatStatusConfig(state, action: PayloadAction<Partial<ChatConfig>>) {
      state.chatConfig = { ...state.chatConfig, ...action.payload };
    },
  },
});

export const { setSalesUserId, setCurrentSessionId, setChatStatusConfig } = chatSlice.actions;

// Selectors
export const salesUserId = (state: RootState) => state?.chat?.salesUserId;
export const currentSessionId = (state: RootState) => state?.chat?.currentSessionId;
export const chatStatusConfig = (state: RootState) => state?.chat?.chatConfig;

export default chatSlice.reducer;
